export class DashboardDetails
{
    //SupplierId?:any;
    EngagementId:any;
    ContractId:any;
}